import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiNoticeSectionDTO extends StrapiDynamicZoneComponentDTO {
  style: "Info" | "Warning" | "Payment";
  content: string;
}

export class NoticeSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  style: "Info" | "Warning" | "Payment";
  content: MDXRemoteSerializeResult;
}
